import { css } from 'styled-components';
import { BreakpointQueryName, ThemedFunctor } from '@doveit/lego';

export const secondaryWrapper = css`
  position: sticky;
  top: 6.5rem;
  padding-bottom: 2rem;
`;

export const requestInfo: ThemedFunctor = ({ theme }) => css`
  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: none;
  }
`;
